import React from "react";
import ServiceTemplate from "../../components/templates/ServiceTemplate";
import businessBg from "../../assets/images/produtos/empresarial.webp";

const BusinessInsurance = () => {
  const serviceData = {
    heroImage: businessBg,
    title: "Seguro Empresarial",
    artigo: "um",
    subtitle: "Proteja sua empresa contra imprevistos com segurança e praticidade",
    color: "indigo",
    icon: "building",
    ramo: "Empresarial",
    pageRamo: true,
    showEmail: true,
    showVeiculo: false,
    formUrl:
      "https://docs.google.com/forms/d/e/1FAIpQLScQc-SPygWVNQn0Zl1IUIqvtMl73Xa1sa_6qW7IaBalG3J5Ug/formResponse",
    mainContent: [
      "O seguro empresarial é essencial para proteger seu negócio contra riscos como incêndios, furtos, danos elétricos, entre outros imprevistos que podem comprometer a operação da empresa. Com o seguro da Free Market Seguros, você garante a continuidade do seu negócio mesmo diante de situações adversas.",
      "Oferecemos soluções sob medida para empresas de todos os portes e segmentos, com coberturas personalizadas e preços acessíveis para proteger seu patrimônio e garantir tranquilidade na gestão.",
    ],
    coverages: [
      "Incêndio, explosão e fumaça",
      "Roubo e furto de bens",
      "Danos elétricos",
      "Quebra de vidros e letreiros",
      "Responsabilidade civil empresarial",
    ],
    additionalCoverages: [
      "Lucros cessantes",
      "Despesas fixas",
      "Equipamentos eletrônicos e máquinas",
      "Danos por vendaval, alagamento e granizo",
      "Assistência 24h (hidráulica, elétrica, chaveiro)",
    ],
    advantages: [
      {
        icon: "briefcase",
        title: "Proteção Patrimonial",
        description:
          "Garante a continuidade das atividades da sua empresa em caso de sinistro",
      },
      {
        icon: "hands-helping",
        title: "Coberturas Personalizadas",
        description:
          "Planos sob medida para o seu tipo de negócio e estrutura",
      },
      {
        icon: "clock",
        title: "Agilidade e Suporte",
        description:
          "Atendimento ágil e suporte durante toda a vigência da apólice",
      },
    ],
    steps: [
      {
        title: "Avaliação da Empresa",
        description:
          "Coletamos informações sobre sua estrutura, bens e operação para entender os riscos envolvidos.",
      },
      {
        title: "Simulação e Propostas",
        description:
          "Você recebe as melhores opções de seguradoras com coberturas compatíveis com seu perfil.",
      },
      {
        title: "Contratação Segura",
        description:
          "Após escolher a proposta ideal, formalizamos a contratação com agilidade e sem burocracia.",
      },
      {
        title: "Gestão Ativa",
        description:
          "Oferecemos suporte contínuo para atualizações e acionamento de cobertura quando necessário.",
      },
    ],
    tip: "Ao contratar um seguro empresarial, analise os riscos específicos do seu negócio e certifique-se de incluir coberturas como lucros cessantes, que podem ser decisivas para manter a operação mesmo diante de imprevistos.",
  };

  return <ServiceTemplate {...serviceData} />;
};

export default BusinessInsurance;